import {InputText, Select} from '@/components/Form/index.mjs'
import FormItemBizProp from '../components/FormItemBizProp.jsx'
import FormChooseDesign from '../_DESIGN/FormChooseDesign.jsx'
import Model from './ModelCdt.mjs'

export const FormItemCdtCat = props => (
    <FormItemBizProp
        Model={Model}
        prop="cdtCat"
        {...props}
    >
        <InputText allowClear />
    </FormItemBizProp>
)

export const FormItemCdtName = props => (
    <FormItemBizProp
        Model={Model}
        prop="cdtName"
        {...props}
    >
        <InputText allowClear />
    </FormItemBizProp>
)

export const FormItemCdtUserCode = props => (
    <FormItemBizProp
        Model={Model}
        prop="cdtUserCode"
        {...props}
    >
        <InputText allowClear />
    </FormItemBizProp>
)

export const FormItemLockFlag = props => (
    <FormItemBizProp
        Model={Model}
        prop="lockFlag"
        {...props}
    >
        <Select
            allowClear
            getOptionKey={e => e[0]}
            getOptionLabel={e => e[1]}
            options={[['0', '否'], ['1', '是']]}
        />
    </FormItemBizProp>
)

export const FormItemIsSeq = props => (
    <FormItemBizProp
        Model={Model}
        prop="isSeq"
        {...props}
    >
        <Select
            allowClear
            getOptionKey={e => e[0]}
            getOptionLabel={e => e[1]}
            options={[['0', '否'], ['1', '是']]}
        />
    </FormItemBizProp>
)

export default function FormChooseCdt(props) {
    return (
        <FormChooseDesign {...props}>
            <FormItemCdtCat />
            <FormItemCdtUserCode />
            <FormItemCdtName />
            <FormItemLockFlag />
            <FormItemIsSeq />
        </FormChooseDesign>
    )
}
